<template>
  <b-card
    no-body
    class="card-company-table"
  >
    <b-card-header>
      <b-card-title>{{ $t('Top 10 Depositors') }}</b-card-title>
      <feather-icon
        icon="RotateCwIcon"
        class="cursor-pointer"
        @click="fetchTopDepositors"
      />
    </b-card-header>

    <b-table
      ref="getTopDepositors"
      :items="currentTopDepositor"
      responsive
      :fields="translatedTableHeaders"
      primary-key="id"
      show-empty
      empty-text="No records available"
      class="mb-0"
    >
      <template #cell(role)="data">
        <p class="text-capitalize">
          {{ data.value }}
        </p>
      </template>
    </b-table>

    <Spinner :show="isLoadingTopDepositors" />
  </b-card>
</template>

<script>
import {
  BCard, BTable, BCardHeader, BCardTitle,
} from 'bootstrap-vue'
import { onMounted, computed, ref } from '@vue/composition-api'
import { useActions } from 'vuex-composition-helpers'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import Spinner from '@/views/components/spinner/Spinner.vue'
import useToastAlert from '../../../composable/useToast'
import { toBalance } from '@/helpers/formatAmount'

export default {
  components: {
    BCard,
    BTable,
    BCardHeader,
    BCardTitle,
    Spinner,
  },

  setup() {
    const { getTopDepositors } = useActions({ getTopDepositors: 'dashboard/getTopDepositors' })
    const { t } = useI18nUtils()
    const { toastAlert } = useToastAlert()
    const currentTopDepositor = ref([])
    const tableHeaders = ref([
      { key: 'S/N', label: 'S/N' },
      { key: 'accountNumber', label: 'Account Number' },
      { key: 'accountName', label: 'Account Name' },
      { key: 'productType', label: 'Product Type' },
      { key: 'amount', label: 'Ledger Balance' },
      { key: 'percentageOfTotalDeposit', label: '% Of Total Deposits' },
    ])
    const translatedTableHeaders = computed(() => tableHeaders.value.map(header => ({ ...header, label: header.label ? t(header.label) : header.key })))
    const isLoadingTopDepositors = ref(false)

    const fetchTopDepositors = async () => {
      try {
        isLoadingTopDepositors.value = true
        const response = await getTopDepositors()

        const { status, data } = response
        if (status === 200 && data) {
          currentTopDepositor.value = data.summary.map((item, index) => ({
            ...item,
            'S/N': index + 1,
            amount: toBalance(item.amount),
          }))

          isLoadingTopDepositors.value = false
        }
      } catch (err) {
        toastAlert(err)
      } finally {
        isLoadingTopDepositors.value = false
      }
    }

    onMounted(async () => {
      await fetchTopDepositors()
    })

    return {
      currentTopDepositor,
      tableHeaders,
      isLoadingTopDepositors,
      fetchTopDepositors,
      translatedTableHeaders,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

.card-company-table ::v-deep td .b-avatar.badge-light-company {
  .dark-layout & {
    background: $theme-dark-body-bg !important;
  }
}
</style>
